module.exports = __webpack_public_path__ + "static/media/twitter1.0515076c.png";